import * as PropTypes from 'prop-types';
import Button from 'antd/lib/button';
import Alert from 'antd/lib/alert';
import { TextField } from '@ackee/mateus';
import { FormattedMessage, useIntl } from 'react-intl';
import Tabs from 'antd/lib/tabs';

import config from 'config/index';

const TabPane = Tabs.TabPane;

const InfoCategoryForm = ({ handleSubmit, submitting, error }) => {
    const intl = useIntl();
    return (
        <form onSubmit={handleSubmit}>
            <h3>
                <FormattedMessage id="form.section.translations" />
            </h3>
            {error && <Alert type="error" message={intl.formatMessage({ id: error })} />}
            <Tabs>
                {config.app.languages.map(lang => (
                    <TabPane tab={<FormattedMessage id={`languages.${lang}`} />} key={lang}>
                        <TextField
                            name={`${lang}.name`}
                            label={intl.formatMessage({ id: `infoCategory.add.form.name.label` })}
                            labelAlign="left"
                            labelCol={{ span: 24 }}
                        />
                    </TabPane>
                ))}
            </Tabs>
            <Button type="primary" htmlType="submit" loading={submitting}>
                <FormattedMessage id="infoCategory.add.form.submit" />
            </Button>
        </form>
    );
};

InfoCategoryForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,

    error: PropTypes.string,
};

InfoCategoryForm.defaultProps = {
    error: null,
};

export default InfoCategoryForm;
